import { DictionaryArticleInterface } from '~/src/repositories/cms/types/cms.types';
import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { getMappedReferralData } from '~/src/repositories/cms/shared/utils/cms.utils';
import type { CmsMappedArticlesInterface } from '~/src/repositories/cms/types/cms.articles.types';
import type { DirectoryRecordsInterface } from '~/src/repositories/cms/types/cms.directory.types';

export const getMappedKnowledgeBaseData = (
    productGroups: DirectoryRecordsInterface[] | [],
    knowledgeBaseProductGroup: DictionaryArticleInterface[],
    knowledgeBaseProductCards: DictionaryArticleInterface[],
) => {
    const articleKnowledgeBaseProductGroup = knowledgeBaseProductGroup[0]?.articles;
    const articleKnowledgeBaseProductCards = knowledgeBaseProductCards[0]?.articles;

    return productGroups?.map((elem) => {
        const currentArticleKnowledgeBaseProductGroup = articleKnowledgeBaseProductGroup?.find(
            (v) =>
                v.attributeCategories?.opisaniye_gruppy?.attributes?.nazvaniye_gruppy?.value?.code === elem?.code &&
                v.status === CmsArticleStatusesEnum.PUBLISHED,
        );
        return {
            id: elem?.id,
            code: elem?.code,
            name: elem?.value,
            smallImage:
                currentArticleKnowledgeBaseProductGroup?.attributeCategories?.opisaniye_gruppy?.attributes?.smallimage
                    ?.value || null,
            bigImage:
                currentArticleKnowledgeBaseProductGroup?.attributeCategories?.opisaniye_gruppy?.attributes?.bigimage
                    ?.value || null,
            tag:
                currentArticleKnowledgeBaseProductGroup?.attributeCategories?.opisaniye_gruppy?.attributes?.tag
                    ?.value || null,
            products:
                articleKnowledgeBaseProductCards
                    ?.filter(
                        (v) =>
                            v.attributeCategories?.otobrazheniye_v_gruppe_produktov?.attributes.productgroup?.value
                                ?.code === elem?.code && v.status === CmsArticleStatusesEnum.PUBLISHED,
                    )
                    ?.map((v) => ({
                        order: v.order,
                        name: v.attributeCategories?.verkhniy_blok?.attributes?.productname?.value,
                        sefUrl: v.sefUrl,
                    })) || null,
            articleKnowledgeBaseProductCards: articleKnowledgeBaseProductCards,
        };
    });
};

export const getMappedAboutProductData = (
    data: CmsMappedArticlesInterface | Record<string, never>,
    knowledgeBaseProductCards: DictionaryArticleInterface[],
) => {
    const newData = getMappedReferralData(data);
    const articleKnowledgeBaseProductCards = knowledgeBaseProductCards[0]?.articles;
    if (newData) {
        const productList = [];

        for (const value of articleKnowledgeBaseProductCards) {
            const statusIsPublished = value.status !== CmsArticleStatusesEnum.PUBLISHED;
            const productGroupCode =
                value.attributeCategories?.otobrazheniye_v_gruppe_produktov?.attributes.productgroup?.value?.code;

            if (productGroupCode !== newData?.productGroupCode || statusIsPublished) {
                continue;
            }

            productList.push({
                order: value.order,
                name: value.attributeCategories?.verkhniy_blok?.attributes?.productname?.value,
                sefUrl: value.sefUrl,
            });
        }

        return {
            ...newData,
            productList,
        };
    }
    return {};
};
